// Select the form element from the document
const form = document.querySelector('form') as HTMLFormElement

// Function to smoothly scroll to a specific fieldset in the form
const moveSlide = (num: number) => {
    const set = form.querySelectorAll('fieldset')[num]
    if (set) {
        set.scrollIntoView({ behavior: 'smooth' })
    }
}

// Add a click event listener to the form
form.addEventListener('click', e => {
    // If the clicked element is an input element
    if (e.target instanceof HTMLInputElement) {
        const inputName = e.target.name
        const inputValue = e.target.value

        let spans: NodeListOf<HTMLSpanElement> | HTMLSpanElement | null = null
        // Depending on the name of the input, select different span elements
        switch (inputName) {
            case 'slogan':
                spans = document.querySelectorAll('span[data-val="slogan"]')
                break

            case 'color_text':
                spans = document.querySelectorAll('span[data-val="color_text"]')
                break

            case 'color_fabric':
                spans = document.querySelectorAll(
                    'span[data-val="color_fabric"]'
                )
                // Select the button from the document
                const btnCheckout = document.querySelector(
                    'button[data-action="checkout"]'
                ) as HTMLButtonElement

                // Set the disabled property to false
                btnCheckout.disabled = false
                break
        }

        // If span elements were selected, update their text
        if (spans) {
            spans.forEach(span => {
                // If the input name is 'slogan', wrap the input value in quotes
                span.innerText =
                    inputName === 'slogan' ? `"${inputValue}"` : inputValue
            })
        }
    }

    // If the clicked element is a button with a 'back' action
    if (
        e.target instanceof HTMLButtonElement &&
        e.target.dataset.action === 'back'
    ) {
        const fieldsets = Array.from(form.querySelectorAll('fieldset'))
        const currentFieldsetIndex = fieldsets.findIndex(fieldset =>
            fieldset.contains(e.target as HTMLButtonElement)
        )
        // If the current fieldset is not the first one, move back to the previous fieldset
        if (currentFieldsetIndex !== -1 && currentFieldsetIndex > 0) {
            moveSlide(currentFieldsetIndex - 1)
        }
    } else if (
        e.target instanceof HTMLInputElement &&
        e.target.type === 'radio'
    ) {
        const fieldsets = Array.from(form.querySelectorAll('fieldset'))
        const currentFieldsetIndex = fieldsets.findIndex(fieldset =>
            fieldset.contains(e.target as HTMLInputElement)
        )
        // If the current fieldset is not the last one, move to the next fieldset
        if (
            currentFieldsetIndex !== -1 &&
            currentFieldsetIndex < fieldsets.length - 1
        ) {
            moveSlide(currentFieldsetIndex + 1)
        }
    }
})

// const form = document.querySelector('form') as HTMLFormElement

// const moveSlide = (num: number) => {
//     const set = form.querySelectorAll('fieldset')[num]
//     if (set) {
//         set.scrollIntoView({ behavior: 'smooth' })
//     }
// }

// form.addEventListener('click', e => {
//     if (e.target instanceof HTMLInputElement) {
//         const inputName = e.target.name
//         const inputValue = e.target.value

//         let spans: NodeListOf<HTMLSpanElement> | HTMLSpanElement | null = null
//         switch (inputName) {
//             case 'slogan':
//                 spans = document.querySelectorAll('span[data-val="slogan"]')
//                 break

//             case 'color_text':
//                 spans = document.querySelectorAll('span[data-val="color_text"]')
//                 break

//             case 'color_fabric':
//                 spans = document.querySelectorAll(
//                     'span[data-val="color_fabric"]'
//                 )
//                 break
//         }

//         if (spans) {
//             spans.forEach(span => {
//                 span.innerText =
//                     inputName === 'slogan' ? `"${inputValue}"` : inputValue
//             })
//         }
//     }

//     if (
//         e.target instanceof HTMLButtonElement &&
//         e.target.dataset.action === 'back'
//     ) {
//         const fieldsets = Array.from(form.querySelectorAll('fieldset'))
//         const currentFieldsetIndex = fieldsets.findIndex(fieldset =>
//             fieldset.contains(e.target as HTMLButtonElement)
//         )
//         if (currentFieldsetIndex !== -1 && currentFieldsetIndex > 0) {
//             moveSlide(currentFieldsetIndex - 1)
//         }
//     } else if (
//         e.target instanceof HTMLInputElement &&
//         e.target.type === 'radio'
//     ) {
//         const fieldsets = Array.from(form.querySelectorAll('fieldset'))
//         const currentFieldsetIndex = fieldsets.findIndex(fieldset =>
//             fieldset.contains(e.target as HTMLInputElement)
//         )
//         if (
//             currentFieldsetIndex !== -1 &&
//             currentFieldsetIndex < fieldsets.length - 1
//         ) {
//             moveSlide(currentFieldsetIndex + 1)
//         }
//     }
// })
